import React, { useEffect } from 'react';
import { useSynapse } from 'app/lib/synaptik';
import { UserNotificationChannels, UserNotificationStatuses, UserNotificationTopics } from '@goodrx/heydoctor-core';
import VerifyPhoneModal from 'app/components/VerifyPhoneModal/VerifyPhoneModal';
import Tenancy from 'app/lib/tenancy';
import { TopicManager } from 'app/components/notifications/TopicManager';

const { SMS, PUSH, IN_APP, EMAIL } = UserNotificationChannels;
const { NEW_MESSAGES } = UserNotificationTopics;
const { DISABLED } = UserNotificationStatuses;

const ChannelConfig = {
  [EMAIL]: {
    iconName: 'email',
    displayName: 'Email Notifications',
    channel: EMAIL,
  },
  [SMS]: {
    iconName: 'cellphone-iphone',
    displayName: 'Text Notifications',
    channel: SMS,
  },
  [PUSH]: {
    iconName: 'cellphone-sound',
    displayName: 'Push Notifications',
    channel: PUSH,
  },
  [IN_APP]: {
    iconName: 'bell',
    displayName: 'App Notifications',
    channel: IN_APP,
  },
};

const buildDefaultChannel = (topic: UserNotificationTopics, channel: UserNotificationChannels) => ({
  topic,
  channel,
  status: DISABLED,
  config: ChannelConfig[channel],
});

const TopicConfig = [
  {
    topic: NEW_MESSAGES,
    topicDisplayName: 'New Messages',
    channels: ([SMS, Tenancy.isHeyDoctor() && PUSH].filter(Boolean) as UserNotificationChannels[]).map((channel) =>
      buildDefaultChannel(NEW_MESSAGES, channel)
    ),
  },
];

export const NotificationCenter = () => {
  const [phoneVerifiedAt, topicToVerify, updateNotificationTopic] = useSynapse(({ user }: any) => [
    user.state.profile?.phoneVerifiedAt,
    user.state.topicToVerify,
    user.updateNotificationTopic,
  ]);

  useEffect(() => {
    if (phoneVerifiedAt && topicToVerify) {
      updateNotificationTopic({ channel: SMS, topic: topicToVerify, status: 'enabled' });
    }
  }, [phoneVerifiedAt, topicToVerify]);

  return (
    <>
      {TopicConfig.map((props) => (
        <TopicManager key={props.topic} {...props} />
      ))}

      <VerifyPhoneModal />
    </>
  );
};
